const getImageAttr = (currentImageAsDomElement, attr) => {
  try {
    const imgEl = currentImageAsDomElement;
    return imgEl.getAttribute(attr);
  } catch (error) {
    return null;
  }
};
export default getImageAttr;